import React from "react";
import { Table, Tag, Space, Button } from "antd";

export default function AssetListTab() {
    const [searchText, setSearchText] = React.useState("");

    const assetData = [
        {
            id: 1,
            name: "SCADA-SERVER-01",
            type: "SCADA",
            ip: "192.168.1.10",
            status: "Active",
            severity: "Critical",
            lastSeen: "2024-01-15 14:32",
        },
        {
            id: 2,
            name: "HMI-WORKSTATION-02",
            type: "HMI",
            ip: "192.168.1.20",
            status: "Active",
            severity: "High",
            lastSeen: "2024-01-15 14:28",
        },
        {
            id: 3,
            name: "INDUSTRIAL-PLC-03",
            type: "Industrial",
            ip: "192.168.1.30",
            status: "Active",
            severity: "Medium",
            lastSeen: "2024-01-15 14:15",
        },
        {
            id: 4,
            name: "NETWORK-DEVICE-04",
            type: "Network",
            ip: "192.168.1.40",
            status: "Inactive",
            severity: "Low",
            lastSeen: "2024-01-14 10:22",
        },
        {
            id: 5,
            name: "IP-CAMERA-LAB-05",
            type: "IP Camera",
            ip: "192.168.1.50",
            status: "Active",
            severity: "Low",
            lastSeen: "2024-01-15 13:45",
        },
        {
            id: 6,
            name: "COMPUTER-WS-06",
            type: "Computer",
            ip: "192.168.1.60",
            status: "Active",
            severity: "High",
            lastSeen: "2024-01-15 14:30",
        },
        {
            id: 7,
            name: "VOIP-PHONE-07",
            type: "VoIP",
            ip: "192.168.1.70",
            status: "Active",
            severity: "Low",
            lastSeen: "2024-01-15 14:05",
        },
        {
            id: 8,
            name: "VIRTUAL-DEVICE-08",
            type: "Virtual Devices",
            ip: "192.168.1.80",
            status: "Active",
            severity: "Medium",
            lastSeen: "2024-01-15 14:20",
        },
    ];

    const getSeverityColor = (severity) => {
        const colorMap = {
            Critical: "#ff4d4f",
            High: "#ff7a45",
            Medium: "#faad14",
            Low: "#52c41a",
        };
        return colorMap[severity];
    };

    const getStatusColor = (status) => {
        return status === "Active" ? "green" : "red";
    };

    const columns = [
        {
            title: "Asset Name",
            dataIndex: "name",
            key: "name",
            width: 150,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            width: 100,
            render: (type) => (
                <Tag color="blue">
                    {type}
                </Tag>
            ),
        },
        {
            title: "IP Address",
            dataIndex: "ip",
            key: "ip",
            width: 120,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 100,
            render: (status) => (
                <Tag color={getStatusColor(status)}>
                    {status}
                </Tag>
            ),
        },
        {
            title: "Severity",
            dataIndex: "severity",
            key: "severity",
            width: 100,
            render: (severity) => (
                <Tag color={getSeverityColor(severity)}>
                    {severity}
                </Tag>
            ),
        },
        {
            title: "Last Seen",
            dataIndex: "lastSeen",
            key: "lastSeen",
            width: 150,
            render: (text) => <span>{text}</span>,
        },
        {
            title: "Action",
            key: "action",
            width: 100,
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="primary"
                        size="small"
                    >
                        View
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div className="card mt-5">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    {/* <h5 className="text-white mb-0">Asset List</h5> */}
                    <span></span>
                    <div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search assets..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>

                </div>
                <Table
                    columns={columns}
                    dataSource={assetData}
                    rowKey="id"
                    className="table antd-override mb-0"
                    pagination={{
                        pageSize: 10,
                        className: 'mb-0',
                        showSizeChanger: true,
                        showTotal: (total, range) => (
                            <span>
                                {range[0]} to {range[1]} of {total} assets
                            </span>
                        ),
                    }}
                />
            </div>
        </div>
    );
}
